import { createEventCreator as event } from './ga';
import { LINK_SELECTED, BUTTON_SELECTED } from 'config/constants/gaCommonActions';

export const stayDateRange = event((dateRange: string) => ({
  category: 'Stay Date Range',
  action: dateRange,
}));

export const openCancellationPolicy = event((location: 'Top' | 'Bottom') => ({
  category: `Cancellation Policy Link`,
  action: `${location} ${BUTTON_SELECTED}`,
}));

export const togglePaymentBreakdown = event((isOpen: boolean) => ({
  category: `Payment Method Breakdown`,
  action: isOpen ? 'Expanded' : 'Collapsed',
}));

export const termsAndConditionsCheckbox = event((checked: boolean) => ({
  category: `Terms And Conditions Checkbox`,
  action: checked ? 'Checked' : 'Unchecked',
}));

export const privacyAndSecurityLink = event(() => ({
  category: `Privacy And Security Link`,
  action: LINK_SELECTED,
}));

export const termsAndConditionsLink = event(() => ({
  category: `Terms And Conditions Link`,
  action: LINK_SELECTED,
}));
